export interface StatisticsDataPoint {
  date: string;
  value: number;
}

export interface RawStatisticsItem {
  data_romaneio?: string;
  data_aprovacao?: string;
  n_antecipacoes?: number | string;
  valor_antecipado_compra?: number | string;
  aderencia?: number | string;
  ticker_medio?: number | string;
  cadastros_aprovados?: number | string;
}

export type StatisticsType =
  | 'antecipacao_dia'
  | 'ticket_medio_dia'
  | 'total_antecipado_dia'
  | 'aderencia'
  | 'cad_aprovados_dia';

export interface StatisticsQueryParams {
  filterDate: string;
  dbName: string;
  ops: string;
}

export interface AllStatisticsData {
  antecipacaoDia: StatisticsDataPoint[];
  ticketMedioDia: StatisticsDataPoint[];
  totalAntecipadoDia: StatisticsDataPoint[];
  aderencia: StatisticsDataPoint[];
  cadAprovadosDia: StatisticsDataPoint[];
}

export const STATISTICS_TYPES: StatisticsType[] = [
  'antecipacao_dia',
  'ticket_medio_dia',
  'total_antecipado_dia',
  'aderencia',
  'cad_aprovados_dia',
];
